var _path, _g, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedInFooterIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3944_394",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 46,
    height: 46
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 44C34.598 44 44 34.598 44 23C44 11.402 34.598 2 23 2C11.402 2 2 11.402 2 23C2 34.598 11.402 44 23 44Z",
    fill: "#F9F5EC",
    stroke: "black",
    strokeWidth: 4
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3944_394)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23 44C34.598 44 44 34.598 44 23C44 11.402 34.598 2 23 2C11.402 2 2 11.402 2 23C2 34.598 11.402 44 23 44Z",
    fill: "#F9F6F1",
    stroke: "black",
    strokeWidth: 4
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9361 19.5761H17.6571V32.5442H13.9361V19.5761ZM15.7018 17.954H15.6748C14.3279 17.954 13.4546 16.9627 13.4546 15.7073C13.4546 14.4262 14.3537 13.4545 15.7276 13.4545C17.1004 13.4545 17.9445 14.4238 17.9714 15.7036C17.9714 16.959 17.1004 17.954 15.7018 17.954ZM32.5455 32.5454H28.3261V25.8334C28.3261 24.0768 27.6661 22.8789 26.2148 22.8789C25.1047 22.8789 24.4873 23.6869 24.2 24.468C24.0922 24.7467 24.109 25.1366 24.109 25.5278V32.5454H19.929C19.929 32.5454 19.9829 20.6566 19.929 19.5761H24.109V21.6113C24.356 20.7214 25.6917 19.4514 27.8233 19.4514C30.4678 19.4514 32.5455 21.3179 32.5455 25.3334V32.5454Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedInFooterIcon);
export default __webpack_public_path__ + "static/media/LinkedInFooterIcon.17e72afe4adb5cd07317d1330125ca3d.svg";
export { ForwardRef as ReactComponent };